import React, { Component } from 'react';
import autoinfoService from '@/service/autoinfo';

class Main extends Component<any, any> {
    public state = {
        title: ['免费信息', '付费信息']
    };

    public render() {
        return (
            <>
                {/* <div className="title">{this.state.title[this.props.type - 1]}</div>
                <div className="button-wrap"> */}
                {this.props.list.map((item: any, index: number) => (
                    <div
                        onClick={this.buttonClick(item.link)}
                        className="button-item"
                        key={index}>
                        <div
                            className={
                                this.props.type === 1
                                    ? 'button-item-container'
                                    : 'button-item-container pay'
                            }>
                            <img className="button-icon" src={item.iconUrl} />
                            <p> {item.name} </p>
                        </div>
                    </div>
                ))}
                {/* </div> */}
            </>
        );
    }

    private buttonClick = (url: string) => {
        return async () => {
            if (this.props.type === 2) {
                // const goOrder = await this.getOrderList();
                // if (goOrder) {
                //     location.href = '/autoinfo/order.html';
                //     return;
                // }
                // const response = await autoinfoService.getUserRights();
                // if (response) {
                //     if (response.status === 1) {
                //         location.href = url;
                //     } else {
                //         location.href = '/autoinfo/buy.html';
                //     }
                // }
                const status = await this.checkStatus(url);
                console.log('status', status);
            } else if (url) {
                location.href = url;
            }
        };
    };

    private async getOrderList() {
        const response = await autoinfoService.getOrderList();
        const list = (response && response.results) || [];
        let goOrder = false;
        if (list && list.length) {
            list.forEach((item: any) => {
                if (item.status === 20) {
                    goOrder = true;
                    // return;
                }
            });
        }
        return goOrder;
    }

    private async checkStatus(url: string) {
        const response = await autoinfoService.checkStatus();
        console.log('response', response);
        if (response) {
            const { isExist, examineStatus, examineExplain } = response;
            if (!isExist) {
                location.href = '/autoinfo/userinfo.html';
            } else if (examineStatus === 10) {
                // 审核通过
                location.href = url;
            } else if (examineStatus === 20) {
                // 审核未通过
                location.href = `/autoinfo/status.html?status=20&examineExplain=${encodeURI(
                    examineExplain
                )}`;
            } else if (examineStatus === 30) {
                // 待审核
                location.href = '/autoinfo/status.html?status=30';
            }
        }
    }
}

export default Main;
